export default __webpack_public_path__ + "static/Benjamin-5a4be6ad5721e77e8e899eeb52a0b5d2.jpeg";